import { FC } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../Logo";
import styles from "./Footer.module.scss";

interface FooterLink {
  label: string;
  to: string;
}

interface FooterColumn {
  heading: string;
  links: FooterLink[];
}

const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: "Product",
    links: [
      {
        label: "Digital Building Information",
        to: "/digital-building-information",
      },
      { label: "Digital O&M", to: "/digital-om" },
      { label: "Documents & Drawings", to: "/documents-drawings" },
      { label: "Asset Information", to: "/asset-information" },
      { label: "Search", to: "/search" },
      { label: "AI", to: "/ai" },
    ],
  },
  {
    heading: "Solutions",
    links: [{ label: "Who It’s For", to: "/who-its-for" }],
  },
  // @todo: add resources back later
  // {
  //   heading: "Resources",
  //   links: [{ label: "Resources", to: "/resources" }],
  // },
  {
    heading: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

interface LegalItem {
  label: string;
  to?: string;
}

const LEGAL_ITEMS: LegalItem[] = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
];

const Footer: FC = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.mainNav}>
        <div className={styles.inner}>
          <div className={styles.navGrid}>
            <div className={styles.brandArea}>
              <Logo variant="light" />

              <p className={styles.brandDescription}>
                Your building information. One place.
              </p>

              <p className={styles.brandSupporting}>
                A secure platform to organise, access and search commercial
                building documentation, drawings and asset data.
              </p>
            </div>

            {FOOTER_COLUMNS.map((column) => (
              <nav
                key={column.heading}
                className={styles.navColumn}
                aria-label={column.heading}
              >
                <h2 className={styles.columnHeading}>{column.heading}</h2>

                <ul className={styles.linkList}>
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <NavLink to={link.to} className={styles.footerLink}>
                        {link.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.bottomBar}>
        <div className={styles.inner}>
          <div className={styles.bottomInner}>
            <p className={styles.copyright}>
              &copy; 2026 Pulse. All rights reserved.
            </p>

            <nav aria-label="Legal information">
              <ul className={styles.legalList}>
                {LEGAL_ITEMS.map((item) => (
                  <li key={item.label}>
                    {item.to ? (
                      <NavLink to={item.to} className={styles.legalLink}>
                        {item.label}
                      </NavLink>
                    ) : (
                      <span className={styles.legalItem}>{item.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
